module.exports = __webpack_public_path__ + "static/media/Akademik.35e775e6.png";